// Also listed in backend/src/registration/dto/register-organisation.dto.ts and
// in the staff_band CHECK constraint. All three have to change together.
// Missing the database one is the damaging case: the band shows in the form and
// then fails registration, rather than simply not being offered.
export const STAFF_BANDS = ['1-9', '10-29', '30-99', '100+'] as const;

export type StaffBand = (typeof STAFF_BANDS)[number];

// Registration is free, so the smallest businesses sign up most readily.
// Counting them alongside everyone else would teach Google Ads to buy more of
// them, so only bands above this one are reported as a qualified signup.
const UNQUALIFIED_BAND: StaffBand = '1-9';

export function isQualifiedBand(band: string) {
  return band !== UNQUALIFIED_BAND;
}
